<template>
  <div class="jCoTPh Personal-Center">
    <!-- <a class="iconfont back" @click="Returngo">&#xe653;</a> -->
    <div class="sc-bwzfXH fNojfq" @click="Returngo">
      <img draggable="false" src="../assets/logo.png" />
    </div>

    <div class="jofBxZ">
      <!-- pc端 -->
      <nav class="sc-laTMn eCpgls">
        <a class="iconfont back" @click="Returngo">&#xe653;</a>
        <div class="sc-jHZirH fYIPfZ">
          <CenterNavSun></CenterNavSun>
        </div>
      </nav>
      <!-- pc结束 -->
      <!-- 内容端 -->
      <main class="sc-cpmLhU ZAAcp">
        <div class="sc-jhAzac">
          <!-- <div class="sc-frDJqD hYKOrR" @click="goCenterNav">
            <a class="iconfont">&#xe653;</a>
            <span class="sc-hqyNC fJxckn">返回个人中心</span>
          </div>-->
          <header class="header-one">
            <div class="mobile-menu-area hidden-lg hidden-md hidden-sm">
              <div class="container mean-container">
                <div class="mean-bar">
                  <a
                    @click="bNav = !bNav"
                    class="meanmenu-reveal"
                    :class="{ meanclose: bNav }"
                    style="right: 0px; left: auto; text-align: center; text-indent: 0px; font-size: 18px;"
                  >
                    <template v-if="!bNav">
                      <span></span>
                      <span></span>
                      <span></span>
                    </template>
                    <template v-else
                      >X</template
                    >
                  </a>
                  <nav class="mean-nav">
                    <ul v-show="bNav">
                      <li
                        v-for="(i, index) in routelist"
                        :key="index"
                        :style="i.style"
                      >
                        <router-link
                          :to="{ path: `/Center${i.path}` }"
                          @click.native="bNav = !bNav"
                          class="router-link-exact-active router-link-active"
                          >{{ i.name }}</router-link
                        >
                      </li>
                      <li>
                        <a
                          class="router-link-exact-active router-link-active"
                          @click="Signout"
                          >退出</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mobile-menu">
                      <div class="logo">
                        <a
                          @click="Returngo"
                          class="navbar-brand page-scroll sticky-logo router-link-exact-active router-link-active"
                        >
                          <img
                            draggable="false"
                            src="/static/img/logo2.60cf6e3.png"
                            alt
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div class="mheing"></div>
          <section class="u-centerper">
            <router-view></router-view>
          </section>
        </div>
      </main>
      <!-- 内容端结束 -->
    </div>
    <div class="OverallTips" v-show="yc">
      <aletBoxtwo @func="gb"></aletBoxtwo>
    </div>
  </div>
</template>
<script>
import CenterNavSun from '@/components/CenterNavSun'
import aletBoxtwo from '@/components/aletBoxtwo'
export default {
  components: { CenterNavSun,aletBoxtwo },
  metaInfo: {
    title:'海星云-个人中心-云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      bNav: false,
      routelist: [
        {
          name: '账号中心',
          path: '/Information',
          img: '../../static/percttent/hui/1.png',
          img2: '../../static/percttent/hei/1.png'
        },
        {
          name: '我的卡包',
          path: '/card',
          img: '../../static/percttent/hui/2.png',
          img2: '../../static/percttent/hei/2.png',
          style: ''
        },
        {
          name: '充值记录',
          path: '/Recharge',
          img: '../../static/percttent/hui/3.png',
          img2: '../../static/percttent/hei/3.png'
        },
        {
          name: '提现记录',
          path: '/Withdrawal',
          img: '../../static/percttent/hui/8.png',
          img2: '../../static/percttent/hei/8.png'
        },
        {
          name: '消费记录',
          path: '/Consumption',
          img: '../../static/percttent/hui/4.png',
          img2: '../../static/percttent/hei/4.png'
        },
        {
          name: '实名认证',
          path: '/Real_name',
          img: '../../static/percttent/hui/5.png',
          img2: '../../static/percttent/hei/5.png'
        },
        {
          name: '安全中心',
          path: '/security',
          img: '../../static/percttent/hui/6.png',
          img2: '../../static/percttent/hei/6.png'
        },
        {
          name: '转账中心',
          path: '/Transfer',
          img: '../../static/percttent/hui/7.png',
          img2: '../../static/percttent/hei/7.png'
        }
      ],
      yc:false
    }
  },
  methods: {
    gb(data){
      this.yc = data
    },
    Returngo () {
      this.$router.push('./Home')
    },
    Signout () {
      window.localStorage.removeItem('state')
      this.$cookieStore.delCookie('user_sess')
      this.$router.push('/Home')
      window.location.reload()
    }
  },
  created(){
    if(this.$route.query.value){
      this.yc = true
    }
  },
  mounted () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      return
    }
    if (this.$route.query.route == 1) {
      this.$router.push('./card')
    }
    this.http.payzhouk().then(res => {
      let payzklist = res.data.data.timecard_list
      if (payzklist.length == 0) {
        this.routelist[1].style = 'display:none'
      } else {
        this.routelist[1].style = ''
      }
    })
      .catch((e) => {
        window.location.reload()
      })
  }
}
</script>
<style lang="scss" scoped>
.back {
  background: #f4c91d;
  color: #000000;
  position: absolute;
  left: 36px;
  height: 30px;
  border-radius: 5px;
  width: 70px;
  box-sizing: border-box;
  padding-left: 20px;
  line-height: 30px;
  font-size: 18px;
  top: -96px;
  cursor: pointer;
}
.sc-bwzfXH {
  margin-bottom: 10px !important;
}
.jhAzac {
  max-width: 1010;
}
.OverallTips{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Center.vue